import React from "react"
import ContentListItem from './content-list-item';

const ContentListItems = ({data, useCounter}) => (Array.isArray(data) && (
        <>
            {data.map((item, index) => {
                return (
                    <ContentListItem
                        key={index}
                        item={item}
                        useCounter = {useCounter}
                    />
                )
            })}
        </>
    ))

export default ContentListItems
